export {}

declare global {
    interface String {
        toPascalCase(): string;
    }
}

String.prototype.toPascalCase = function (this: string): string {
  return this.charAt(0).toUpperCase() + this.slice(1)
}
